export enum ApiVersion {
  IF_WEEKEND_SHIFT = 202411270,
}
